import React from 'react';
import { ChakraProvider } from '@chakra-ui/react';
import {
  Outlet,
  RouterProvider,
  ScrollRestoration,
  createBrowserRouter,
} from 'react-router-dom';

import theme from './theme/theme';
import { homeRoutes } from './router/HomeRoutes';

const Root = () => {
  return (
    <>
      <ChakraProvider theme={theme}>
        <Outlet />
      </ChakraProvider>
      <ScrollRestoration />
    </>
  );
};

const router = createBrowserRouter(
  [
    {
      path: '/',
      element: <Root />,
      children: homeRoutes,
    },
  ],
  {
    //basename: '/aws_ui/ui',
    basename: '/ui',
  }
);

function App() {
  return (
    // スクロール位置をリセットするようにしたが、リセットされない←あとで調べる
    <RouterProvider router={router} />

    // <ChakraProvider theme={theme}>
    //   <BrowserRouter>
    //     <Router />
    //   </BrowserRouter>
    // </ChakraProvider>
  );
}

export default App;
